"use strict";

import moment from 'moment';


module.exports = {
  bindings: {
    formField: '=',
    required: '<',
    fieldName: '<',
    dateType: '<',
    onChange: '&'
  },
  template:
  '    <div class="input-group">' +
  '      <input type="text" class="form-control" name="{{$ctrl.fieldName}}" ng-model="$ctrl.formField" ' +
  '             ng-required="{{$ctrl.required}}" placeholder="T.M.JJJJ" date-time-input="D.M.YYYY" ' +
  '             data-model-type="{{$ctrl.dateType}}" ng-change="{{$ctrl.onChangeCb()}}">' +
  '      <span class="input-group-addon transparent">' +
  '        <a role="button" data-toggle="modal" data-target="{{\'#dropdown-\' + $ctrl.fieldName}}">' +
  '          <i class="fa fa-calendar fa-circle-thinner"></i>' +
  '        </a>' +
  '      </span>' +
  '    </div>' +
  '  <div class="modal fade" ng-attr-id="{{\'dropdown-\' + $ctrl.fieldName}}"" tabindex="-1" role="dialog">' +
  '    <div class="modal-dialog datepicker" role="document">' +
  '      <div class="modal-content"><div class="modal-body">' +
  '        <datetimepicker ng-model="$ctrl.formField" ' +
  '                        datetimepicker-config="$ctrl.pickerConfig"></datetimepicker>' +
  '<button type="button" class="btn btn-discard" ng-click="$ctrl.onSubmit()" data-dismiss="modal">Übernehmen</button>' +
  '<button type="button" class="btn btn-primary" ng-click="$ctrl.selectToday()" data-dismiss="modal">Heute</button>' +
  '</div></div></div></div>',
  controller: function(){
    var ctrl = this;

    ctrl.$onInit = function(){
      ctrl.dateType = ctrl.dateType || 'Date';

      ctrl.pickerConfig = {
        minView: 'day',
        modelType: ctrl.dateType
      };

    };

    ctrl.onChangeCb = function(){
      ctrl.onChange();
    };

    ctrl.selectToday = function(){
      var now = moment();
      ctrl.formField = ctrl.dateType === 'Date' ? now.toDate() : now.format('DD.MM.YYYY');
    };
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/emil-datepicker.js